import { API_URLS, REQUEST_HEADERS } from '_constants';
import * as TYPES from './DrivingDirections.types';

export const getDrivingDirectionsList = () => ({
  types: [
    TYPES.GET_DRIVING_DIRECTIONS_LIST,
    TYPES.GET_DRIVING_DIRECTIONS_LIST_SUCCESS,
    TYPES.GET_DRIVING_DIRECTIONS_LIST_FAIL,
  ],
  promise: (client) => client.get(`${API_URLS.savedDirections}`),
});

export const getDrivingDirection = (id) => {
  return {
    types: [TYPES.GET_DRIVING_DIRECTION, TYPES.GET_DRIVING_DIRECTION_SUCCESS, TYPES.GET_DRIVING_DIRECTION_FAIL],
    promise: (client) => client.get(`${API_URLS.savedDirections}/${id}?include=driving_points`),
  };
};

export const postDrivingDirection = (data) => {
  return {
    types: [TYPES.POST_DRIVING_DIRECTION, TYPES.POST_DRIVING_DIRECTION_SUCCESS, TYPES.POST_DRIVING_DIRECTION_FAIL],
    promise: (client) => client.post(`${API_URLS.savedDirections}`, data, { headers: { ...REQUEST_HEADERS } }),
  };
};

export const patchSelectedDrivingDirection = (id) => {
  return {
    types: [
      TYPES.PATCH_SELECTED_DRIVING_DIRECTION,
      TYPES.PATCH_SELECTED_DRIVING_DIRECTION_SUCCESS,
      TYPES.PATCH_SELECTED_DRIVING_DIRECTION_FAIL,
    ],
    promise: (client) =>
      client.patch(`${API_URLS.savedDirections}/${id}/set-default`, { headers: { ...REQUEST_HEADERS } }),
  };
};

export const patchRemoveDefaultDirection = (id) => {
  return {
    types: [
      TYPES.PATCH_SELECTED_DRIVING_DIRECTION,
      TYPES.PATCH_SELECTED_DRIVING_DIRECTION_SUCCESS,
      TYPES.PATCH_SELECTED_DRIVING_DIRECTION_FAIL,
    ],
    promise: (client) =>
      client.patch(`${API_URLS.savedDirections}/${id}/remove-default`, { headers: { ...REQUEST_HEADERS } }),
  };
};

export const deleteDrivingDirection = (id) => {
  return {
    types: [
      TYPES.REMOVE_DEFAULT_DIRECTION,
      TYPES.REMOVE_DEFAULT_DIRECTION_SUCCESS,
      TYPES.REMOVE_DEFAULT_DIRECTION_FAIL,
    ],
    promise: (client) => client.delete(`${API_URLS.savedDirections}/${id}`),
  };
};

export const clearSelectedDirection = () => ({
  type: TYPES.CLEAR_SELECTED_DIRECTION,
});
